module.exports = __webpack_public_path__ + "static/img/Group.b91af05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/Group.png
// module id = dSQv
// module chunks = 150